import * as React from 'react'

import WaveContainer from '../../components/wave-container'

import DooerLive from '../../sections/dooer-live'
import Engagement from '../../sections/engagement'
import Footer from '../../sections/footer'
import Instagram from '../../sections/instagram'
import Hero from './components/hero'
import styles from './start.module.scss'
import Seo from '../../components/seo'

export default class Start extends React.Component {
  render() {
    return (
      <>
        <Seo
          description="Dooers bokföringsprogram - gratis för alltid! Voitto har tagit över redovisningsbyrån från Dooer. Letar du efter en redovisningsbyrå? Besök voitto.se."
          image="https://www.dooer.com/images/og/og_index.jpg"
          title="Dooers redovisningsbyrå heter nu Voitto"
          url="https://www.dooer.com/byra"
        />
        <Hero variant="promoNewCompanies" />
        <WaveContainer className={styles.wave} />
        <Engagement />
        <Instagram />
        <DooerLive inverted />
        <Footer inverted />
      </>
    )
  }
}
